import { Injectable } from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
/**
 * @Description this is an interceptor fortokeninterceptor
 * @date 2024-15-04
 * @returns void
 */
export class TokenServiceInterceptor implements HttpInterceptor {

    constructor() {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url.includes(environment.endpoints.auth.name)) {
          return next.handle(req).pipe(
            catchError((error) => {
              return throwError(error);
            })
          );
        }
        if (req.url.includes(environment.endpoints.productosMediadores.name)) {
          return next.handle(req);
        }
        const modifiedReq = req.clone(
          {
            headers: req.headers.set('x-api-key', environment.apikey)
          }
        );



        return next.handle(modifiedReq);

    }
}
